(function () {
  'use strict';

  var form = document.querySelector('form.cert-enroll__form');
  if (!form) return;

  var variantInput = form.querySelector('#cert-variant-id') || form.querySelector('input[name="id"]');
  var sellingPlanInput = form.querySelector('input[name="selling_plan"]');
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    form.appendChild(sellingPlanInput);
  }

  function activeVariantId() {
    return variantInput ? String(variantInput.value || '').trim() : '';
  }

  // Returns the Loop container that actually belongs to the
  // currently selected variant, e.g. #loop-43980779847745-...
  function activeVariantScope() {
    var variantId = activeVariantId();
    if (!variantId) return document;
    var groups = document.querySelectorAll('.loop-subscription-group[id^="loop-' + variantId + '-"]');
    if (!groups.length) return document;
    // Return a lightweight scope object exposing the same
    // querySelector/querySelectorAll surface we need, limited
    // to elements whose closest matching group belongs to this
    // variant.
    return {
      groups: Array.prototype.slice.call(groups),
      querySelectorAllRadios: function () {
        var radios = [];
        groups.forEach(function (g) {
          radios = radios.concat(Array.prototype.slice.call(g.querySelectorAll('input[name="loop_purchase_option"]')));
        });
        return radios;
      }
    };
  }

  function currentCheckedRadioForActiveVariant() {
    var scope = activeVariantScope();
    if (scope === document) {
      return document.querySelector('input[name="loop_purchase_option"]:checked');
    }
    var radios = scope.querySelectorAllRadios();
    return radios.find(function (r) { return r.checked; }) || null;
  }

  function syncSellingPlan() {
    var checked = currentCheckedRadioForActiveVariant();

    if (!checked || checked.dataset.id === 'loop-one-time-purchase') {
      sellingPlanInput.value = '';
      return;
    }

    var wrapper = checked.closest('.loop-subscription-group');
    var select = wrapper && wrapper.querySelector('select');
    var option = select && select.options[select.selectedIndex];
    sellingPlanInput.value = option ? option.value : '';
  }

  // Re-sync whenever a purchase option changes, or the variant
  // itself changes (e.g. Member vs Non-Member swap).
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.name === 'loop_purchase_option' || e.target === variantInput) {
      // Loop needs a tick to update its internal <select> after
      // a radio change before we read it back.
      setTimeout(syncSellingPlan, 30);
    }
  });

  // Watch for variant swaps that happen via URL param reload or
  // programmatic updates rather than a plain change event.
  if (variantInput) {
    var lastVariant = activeVariantId();
    new MutationObserver(function () {
      var v = activeVariantId();
      if (v !== lastVariant) {
        lastVariant = v;
        setTimeout(syncSellingPlan, 30);
      }
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Initial sync once Loop has had a chance to render.
  setTimeout(syncSellingPlan, 800);
  setTimeout(syncSellingPlan, 1800);

  /**
   * ---------- Price display fix ----------
   *
   * BUG: Some subscription-plan rows show the full one-time price
   * (e.g. $697.00) instead of the correct per-installment amount,
   * until the user clicks a radio,  at which point Loop recomputes
   * it correctly. This affects some (variant, plan) pairs and not
   * others, inconsistently, on page load.
   *
   * ROOT CAUSE: at least one selling_plan_group_id (the "4 Monthly
   * Payments" group) is SHARED across both product variants, with
   * a different selling_plan.id nested inside per variant. Loop's
   * own hydration logic appears to get confused about which
   * variant's plan to price when a group id isn't exclusive to one
   * variant, and only fixes itself after a user interaction
   * forces a recompute.
   *
   * FIX: Read the authoritative price for every (variant, plan)
   * pair straight from the product JSON
   * (/products/{handle}.js → variant.selling_plan_allocations),
   * and write it directly into the matching
   * `#loop-price-{variantId}-{groupId}` element. This never
   * depends on Loop's own hydration timing.
   */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  var DEBUG = false; 

  function fixDisplayedPrices() {
    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) {
      if (DEBUG) console.log('[grief-price-fix] no /products/ in pathname, aborting');
      return;
    }
    handle = handle.split('/')[0].split('?')[0].split('#')[0];

    if (DEBUG) console.log('[grief-price-fix] run,  handle:', handle);

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.variants) {
          if (DEBUG) console.log('[grief-price-fix] no data.variants in response', data);
          return;
        }

        if (DEBUG) {
          console.log('[grief-price-fix] variants in product JSON:',
            data.variants.map(function (v) { return v.id + ' (' + v.title + ')'; }));
        }

        var totalGroupsFound = 0;
        var totalElementsMatched = 0;
        var totalElementsUpdated = 0;

        data.variants.forEach(function (variant) {
          var allocations = variant.selling_plan_allocations || [];
          allocations.forEach(function (alloc) {
            var groupId = alloc.selling_plan_group_id;
            if (!groupId) return;
            totalGroupsFound++;

            var expectedId = 'loop-price-' + variant.id + '-' + groupId;
            var priceEl = document.getElementById(expectedId);

            if (DEBUG) {
              console.log(
                '[grief-price-fix] variant', variant.id,
                '| group', groupId,
                '| expected DOM id:', expectedId,
                '| element found:', !!priceEl,
                '| correct price:', formatMoney(alloc.price)
              );
            }

            if (!priceEl) return;
            totalElementsMatched++;

            var correctPrice = formatMoney(alloc.price);
            var currentText = priceEl.textContent.replace(/\s+/g, ' ').trim();

            if (DEBUG) {
              console.log(
                '[grief-price-fix]   current text:', JSON.stringify(currentText),
                '| will overwrite:', currentText !== correctPrice
              );
            }

            if (currentText !== correctPrice) {
              priceEl.textContent = correctPrice;
              totalElementsUpdated++;
            }
          });
        });

        if (DEBUG) {
          console.log(
            '[grief-price-fix] SUMMARY,  allocations checked:', totalGroupsFound,
            '| DOM elements matched:', totalElementsMatched,
            '| elements actually updated:', totalElementsUpdated
          );
        }
      })
      .catch(function (err) {
        // Non-critical: worst case the price display stays stale
        // until the user interacts with a radio, same as before.
        console.warn('[grief-price-fix] fetch/parse error', err);
      });
  }

  // Loop renders its widget asynchronously after the section
  // mounts, so try a few times rather than once.
  [500, 1200, 2200, 3500].forEach(function (delay) {
    setTimeout(fixDisplayedPrices, delay);
  });

  // Re-check whenever the variant changes (Members / Non-Members
  // toggle), since a different variant's group prices may need
  // to be (re)written into the now-visible widget.
  if (variantInput) {
    var lastVariantForPrice = activeVariantId();
    new MutationObserver(function () {
      var v = activeVariantId();
      if (v !== lastVariantForPrice) {
        lastVariantForPrice = v;
        setTimeout(fixDisplayedPrices, 200);
        setTimeout(fixDisplayedPrices, 900);
      }
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }
})();